// extracted by mini-css-extract-plugin
export default {"loader":"LoadingDots_loader__xlOVe","loaderDotsKeyframes":"LoadingDots_loaderDotsKeyframes__Su88T","miniLoader":"LoadingDots_miniLoader__udmD3"};